import { createFeature, createReducer, on } from '@ngrx/store';
import { actions } from './ui.actions';

interface UiState {
    showMenu: boolean;
}

const initialState: UiState = {
    showMenu: false,
};

export const state = createFeature({
    name: 'ui',
    reducer: createReducer(
        initialState,

        on(
            actions.showMenu,
            (state): UiState => ({
                ...state,
                showMenu: true,
            }),
        ),
        on(
            actions.hideMenu,
            (state): UiState => ({
                ...state,
                showMenu: false,
            }),
        ),
    ),
});
